import ConnectToStores from '../Utilities/Decorators/ConnectToStoresDecorator';
import React from 'react';
import PropTypes from 'prop-types';
import NavigationMenuView from './Header/NavigationMenu/NavigationMenuView.jsx';
import UserMenuView from './Header/UserMenuView.jsx';
import PageTitleBarView from './Header/PageTitleBarView.jsx';
import NavigationActions from '../Actions/NavigationActions';
import ProfileActions from '../Actions/ProfileActions';
import NavigationStore from '../Stores/NavigationStore';
import ProfileStore from '../Stores/ProfileStore';
import StickyNotificationsView from './StickyNotificationsView.jsx';
import NotFoundView from './NotFoundView.jsx';
import applyDecoratorsDoNotUseInNewCode from '../Utilities/Decorators/ApplyDecorators.js';
import HelpLinkView from "./Header/HelpLinkView";

class MasterPageView extends React.Component {
    static getStores() {
        return [NavigationStore, ProfileStore];
    }

    static getPropsFromStores() {
        return {
            menu: NavigationStore.getState().menu,
            helpLink: NavigationStore.getState().currentPageHelpLink,
            profile: ProfileStore.getState().profile
        }
    }

    render() {
        return (
            <section>
                <header>
                    <span className="business heading">{ this.props.profile.getIn(['business', 'name']) }</span>
                    <nav className="primary nav">
                        <NavigationMenuView menuItems={ this.props.menu } />
                        <HelpLinkView link={ this.props.helpLink } />
                        <UserMenuView user={ this.props.profile.get('user')  } />
                    </nav>
                </header>
                <PageTitleBarView />
                <StickyNotificationsView />
                <main>
                    {
                        this.props.children ?
                            this.props.children :
                            <NotFoundView />
                    }
                </main>
            </section>
        );
    }

    componentDidMount(){
        NavigationActions.loadMenu();
        ProfileActions.loadProfile();
    }
}

MasterPageView.propTypes = {
    title: PropTypes.string
};

const withDecorators = applyDecoratorsDoNotUseInNewCode(ConnectToStores);

export default withDecorators(MasterPageView);
